/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconNuclear: {
  name: 'nuclear';
  data: string;
} = {
  name: 'nuclear',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M305.796 159.752c-129.339 0-321.534-114.816-291.084 161.754h.001c10.89 98.916 95.127 154.081 168.599 128.144 39.412-13.913 88.589-106.312 122.485-106.312s83.073 92.4 122.485 106.312c73.47 25.935 156.237-29.451 168.599-128.144 34.734-277.343-165.72-161.754-291.085-161.754zM86.051 254.001c51.876-51.177 103.753-46.882 155.629 0-51.876 65.349-129.691 44.279-155.629 0zm278.116 0c51.877-46.882 103.753-51.177 155.629 0-25.938 44.279-103.753 65.349-155.629 0z"/></svg>`,
};
